import { forwardRef, type SVGProps } from 'react';

export type GoogleDriveProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const GoogleDrive = forwardRef<SVGSVGElement, GoogleDriveProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" viewBox="0 0 32 32">
    <path d="M8 26.573l4-6.667h16l-4 6.667H8z" fill="#2684fc" />
    <path d="M20 19.906h8L20 6.573h-8l8 13.333z" fill="#ffba00" />
    <path d="M4 19.906l4 6.667 8-13.333-4-6.667-8 13.333z" fill="#00ac47" />
  </svg>
));
GoogleDrive.displayName = 'GoogleDrive';
